
    import './styles.scoped.css';
    export default {
  "visible-content": "awsui_visible-content_tc96w_13m3z_281",
  "visible-content-toggle": "awsui_visible-content-toggle_tc96w_13m3z_282",
  "visible-content-groups": "awsui_visible-content-groups_tc96w_13m3z_283",
  "visible-content-group": "awsui_visible-content-group_tc96w_13m3z_283",
  "visible-content-title": "awsui_visible-content-title_tc96w_13m3z_288",
  "visible-content-group-label": "awsui_visible-content-group-label_tc96w_13m3z_298",
  "visible-content-option": "awsui_visible-content-option_tc96w_13m3z_304",
  "visible-content-option-label": "awsui_visible-content-option-label_tc96w_13m3z_317",
  "content-display-option-toggle": "awsui_content-display-option-toggle_tc96w_13m3z_604",
  "content-display-option-content": "awsui_content-display-option-content_tc96w_13m3z_608",
  "content-display-option": "awsui_content-display-option_tc96w_13m3z_604",
  "placeholder": "awsui_placeholder_tc96w_13m3z_658",
  "sorting": "awsui_sorting_tc96w_13m3z_658",
  "content-display-option-label": "awsui_content-display-option-label_tc96w_13m3z_685",
  "drag-overlay": "awsui_drag-overlay_tc96w_13m3z_692",
  "content-display": "awsui_content-display_tc96w_13m3z_604",
  "content-display-title": "awsui_content-display-title_tc96w_13m3z_725",
  "content-display-description": "awsui_content-display-description_tc96w_13m3z_734",
  "content-display-option-list": "awsui_content-display-option-list_tc96w_13m3z_742",
  "root": "awsui_root_tc96w_13m3z_749",
  "modal-root": "awsui_modal-root_tc96w_13m3z_750",
  "trigger-button": "awsui_trigger-button_tc96w_13m3z_751",
  "cancel-button": "awsui_cancel-button_tc96w_13m3z_752",
  "confirm-button": "awsui_confirm-button_tc96w_13m3z_753",
  "custom": "awsui_custom_tc96w_13m3z_754",
  "second-column-small": "awsui_second-column-small_tc96w_13m3z_758",
  "wrap-lines": "awsui_wrap-lines_tc96w_13m3z_762",
  "striped-rows": "awsui_striped-rows_tc96w_13m3z_763",
  "content-density": "awsui_content-density_tc96w_13m3z_764",
  "page-size": "awsui_page-size_tc96w_13m3z_765",
  "page-size-form-field": "awsui_page-size-form-field_tc96w_13m3z_766",
  "page-size-radio-group": "awsui_page-size-radio-group_tc96w_13m3z_767",
  "sticky-columns": "awsui_sticky-columns_tc96w_13m3z_768",
  "sticky-columns-form-field": "awsui_sticky-columns-form-field_tc96w_13m3z_769",
  "sticky-columns-radio-group": "awsui_sticky-columns-radio-group_tc96w_13m3z_770",
  "sticky-columns-first": "awsui_sticky-columns-first_tc96w_13m3z_771",
  "sticky-columns-last": "awsui_sticky-columns-last_tc96w_13m3z_772"
};
  